// extracted by mini-css-extract-plugin
export default {"sectionTitle":"price_sectionTitle__qXSH-","priceRangeWrapper":"price_priceRangeWrapper__jm0Ep","priceRange":"price_priceRange__cL5Ln","priceDisplay":"price_priceDisplay__na4e2"};